import { assert } from '@sindresorhus/is';
import { useContext } from 'react';
import { useStore } from 'zustand';

import { SkillActionStoreContext } from './SkillActionSwitcherProvider';
import type { SkillActionStore } from './skill-action-store';

export const useSkillActionStore = <T>(selector: (state: SkillActionStore) => T): T => {
    const skillActionStoreContext = useContext(SkillActionStoreContext);

    assert.plainObject(skillActionStoreContext);

    return useStore(skillActionStoreContext, selector);
};
